/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ActorType = core.serialization.enum_(["account", "user", "guest", "agent", "api_key", "job"]);
